import { Injectable } from '@angular/core';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { IAddressBasicData } from './address';
import { Nexus } from '@tomandco/nexus-api-types';
import find from 'lodash-es/find';

@Injectable({
    providedIn: 'root'
})
export class AddressService {
    constructor(private dfApiConfigService: DfApiConfigService) {}

    getRegionFromAddress(address?: IAddressBasicData): string {
        if (address) {
            const { country_id, region_id } = address;
            if (country_id && region_id) {
                const matchingRegion = this.getCountryRegionFromCountryId(country_id, region_id);
                if (matchingRegion) {
                    return matchingRegion.code || '';
                }
            }
        }
        return address?.region || '';
    }

    getCountryRegionFromCountryId(countryId: string, regionId?: number | string, code?: string): Nexus.Lib.General.Region | undefined {
        if (regionId || code) {
            const matchingCountry = this.getCountryFromAddress(countryId);
            if (matchingCountry) {
                return this.getRegionFromCountry(matchingCountry, regionId, code);
            }
        }
        return undefined;
    }

    getRegionFromCountry(
        country: Nexus.Lib.General.Country,
        regionId?: number | string,
        regionCode?: string
    ): Nexus.Lib.General.Region | undefined {
        if (country?.regions?.length && (regionId || regionCode)) {
            return country.regions.find(region => {
                if (regionId) {
                    // tslint:disable-next-line: triple-equals
                    return region.id == regionId;
                } else if (regionCode) {
                    return regionCode.toLowerCase() === region.code?.toString().toLowerCase();
                }
                return false;
            });
        }
        return undefined;
    }

    getCountryFromAddress(countryId: string): Nexus.Lib.General.Country | undefined {
        return countryId ? this.countries.find(country => country.code === countryId) : undefined;
    }

    areSame(a: IAddressBasicData, b: IAddressBasicData): boolean {
        if (!a || !b) {
            return false;
        }
        if (a.customer_address_id && a.customer_address_id === b.customer_address_id) {
            return true;
        }
        return !find(
            ['firstname', 'lastname', 'city', 'postcode', 'street_1', 'street_2', 'country_id', 'region_id', 'region'],
            field => a[field] !== b[field]
        );
    }

    private get countries(): Nexus.Lib.General.Country[] {
        return this.dfApiConfigService.countries || [];
    }
}
